export const isBrowser: boolean = typeof window !== 'undefined';
export const getIsIntersectionObserverSupported = (): boolean => isBrowser && window.IntersectionObserver !== undefined;
